/*============================================================================
  Ajax the add to cart experience by revealing it in a side drawer
  Plugin Documentation - http://shopify.github.io/Timber/#ajax-cart
  (c) Copyright 2015 Shopify Inc. Author: Carson Shold (@cshold). All Rights Reserved.

  This file includes:
    - Basic Shopify Ajax API calls
    - Ajax cart plugin

  This requires:
    - jQuery 1.8+
    - handlebars.min.js (for cart template)
    - modernizer.min.js
    - snippet/ajax-cart-template.liquid

  Customized version of Shopify's jQuery API
  (c) Copyright 2009-2015 Shopify Inc. Author: Caroline Schnapp. All Rights Reserved.
==============================================================================*/
if ((typeof ShopifyAPI) === 'undefined') { ShopifyAPI = {}; }

/*============================================================================
  API Helper Functions
==============================================================================*/
function attributeToString(attribute) {
  if ((typeof attribute) !== 'string') {
    attribute += '';
    if (attribute === 'undefined') {
      attribute = '';
    }
  }
  return jQuery.trim(attribute);
};

/*============================================================================
  API Functions
==============================================================================*/
ShopifyAPI.onCartUpdate = function(cart) {
  // alert('There are now ' + cart.item_count + ' items in the cart.');
};

ShopifyAPI.updateCartNote = function(note, callback) {
  var params = {
    type: 'POST',
    url: '/cart/update.js',
    data: 'note=' + attributeToString(note),
    dataType: 'json',
    success: function(cart) {
      if ((typeof callback) === 'function') {
        callback(cart);
      }
      else {
        ShopifyAPI.onCartUpdate(cart);
      }
    },
    error: function(XMLHttpRequest, textStatus) {
      ShopifyAPI.onError(XMLHttpRequest, textStatus);
    }
  };
  jQuery.ajax(params);
};

ShopifyAPI.onError = function(XMLHttpRequest, textStatus) {
  var data = eval('(' + XMLHttpRequest.responseText + ')');
  if (!!data.message) {
    alert(data.message + '(' + data.status  + '): ' + data.description);
  }
};

/*============================================================================
  POST to cart/add.js returns the JSON of the cart
    - Allow use of form element instead of just id
    - Allow custom error callback
==============================================================================*/
ShopifyAPI.addItemFromForm = function(form, callback, errorCallback) {
  var params = {
    type: 'POST',
    url: '/cart/add.js',
    data: jQuery(form).serialize(),
    dataType: 'json',
    success: function(line_item) {
      if ((typeof callback) === 'function') {
        callback(line_item, form);
      }
      else {
        ShopifyAPI.onItemAdded(line_item, form);
      }
    },
    error: function(XMLHttpRequest, textStatus) {
      if ((typeof errorCallback) === 'function') {
        errorCallback(XMLHttpRequest, textStatus);
      }
      else {
        ShopifyAPI.onError(XMLHttpRequest, textStatus);
      }
    }
  };
  jQuery.ajax(params);
};

// Get from cart.js returns the cart in JSON
ShopifyAPI.getCart = function(callback, productId, errorMessage) {
  jQuery.getJSON('/cart.js', function (cart, textStatus) {
    if ((typeof callback) === 'function') {
      callback(cart, productId, errorMessage);
    }
    else {
      ShopifyAPI.onCartUpdate(cart);
    }
  });
};

// POST to cart/change.js returns the cart in JSON
ShopifyAPI.changeItem = function(line, quantity, callback) {
  var params = {
    type: 'POST',
    url: '/cart/change.js',
    data: 'quantity=' + quantity + '&line=' + line,
    dataType: 'json',
    success: function(cart) {
      // return quantity error when the ajaxcart_qty-adjust buttons clicks
      var ajaxCart = $(".ajaxcart__qty-num[data-line='" + line + "']");
      var currentItem = cart.items[line - 1];
      var currentQuantity = ajaxCart.val();
      var $currentId = ajaxCart.data("id");

        if ((typeof callback) === 'function') {
            var errorMessage = "";
            if (currentItem && currentItem.quantity != currentQuantity) {
                errorMessage = "All " + currentItem.quantity + " " + currentItem.product_title + " - " + currentItem.variant_options + " are in your cart.";
            }
            callback(cart, $currentId, errorMessage);
        }
        else {
            ShopifyAPI.onCartUpdate(cart);
        }

    },
    error: function(XMLHttpRequest, textStatus) {
      ShopifyAPI.onError(XMLHttpRequest, textStatus);
    }
  };
  jQuery.ajax(params);
};

/*============================================================================
  Ajax Shopify Add To Cart
==============================================================================*/
var ajaxCart = (function(module, $) {

  'use strict';

  // Public functions
  var init, loadCart;

  // Private general variables
  var settings, isUpdating, $body;

  // Private plugin variables
  var $formContainer, $addToCart, $cartCountSelector, $cartCostSelector, $cartContainer, $drawerContainer;

  // Private functions
  var updateCountPrice, formOverride, itemAddedCallback, itemErrorCallback, cartUpdateCallback, buildCart, cartCallback, adjustCart, adjustCartCallback, createQtySelectors, qtySelectors, validateQty, freeGiftHandler, variantSelector;

  var justRanRemove = false;
  /*============================================================================
    Initialise the plugin and define global options
  ==============================================================================*/
  init = function (options) {

    // Default settings
    settings = {
      formSelector       : 'form[action^="/cart/add"]',
      cartContainer      : '#CartContainer',
      addToCartSelector  : 'input[type="submit"]',
      cartCountSelector  : null,
      cartCostSelector   : null,
      moneyFormat        : '$',
      disableAjaxCart    : false,
      enableQtySelectors : true
    };

    // Override defaults with arguments
    $.extend(settings, options);

    // Select DOM elements
    $formContainer     = $(settings.formSelector);
    $cartContainer     = $(settings.cartContainer);
    $addToCart         = $formContainer.find(settings.addToCartSelector);
    $cartCountSelector = $(settings.cartCountSelector);
    $cartCostSelector  = $(settings.cartCostSelector);

    // General Selectors
    $body = $('body');

    // Track cart activity status
    isUpdating = false;

    // Setup ajax quantity selectors on the any template if enableQtySelectors is true
    if (settings.enableQtySelectors) {
      qtySelectors();
    }

    // Take over the add to cart form submit action if ajax enabled
    if (!settings.disableAjaxCart && $addToCart.length) {
      formOverride();
    }

    // Run this function in case we're using the quantity selector outside of the cart
    adjustCart();
  };

  loadCart = function () {
    $body.addClass('drawer--is-loading');
    ShopifyAPI.getCart(cartUpdateCallback);
  };

  updateCountPrice = function (cart) {
    if ($cartCountSelector) {
      $cartCountSelector.html("(" + cart.item_count + ")").removeClass('hidden-count');

      if (cart.item_count === 0) {
        $cartCountSelector.addClass('hidden-count');
      }
    }
    if ($cartCostSelector) {
      $cartCostSelector.html(Shopify.formatMoney(cart.total_price, settings.moneyFormat));
    }
  };

  formOverride = function () {
    $formContainer.off('submit');
    $formContainer.on('submit', function(evt) {
      evt.preventDefault();

      // Add class to be styled if desired
      $addToCart.removeClass('is-added').addClass('is-adding');

      // Remove any previous quantity errors
      $('.qty-error').remove();
      ShopifyAPI.addItemFromForm(evt.target, itemAddedCallback, itemErrorCallback);
    });
  };

  itemAddedCallback = function (product) {
    $addToCart.removeClass('is-adding').addClass('is-added');

    ShopifyAPI.getCart(cartUpdateCallback);
  };

  itemErrorCallback = function (XMLHttpRequest, textStatus) {
    var data = eval('(' + XMLHttpRequest.responseText + ')');
    $addToCart.removeClass('is-adding is-added');

    if (!!data.message) {
      $('.qty-error').remove();
      if (data.status == 422) {
        $formContainer.after('<div class="errors qty-error">'+ String(data.description).replace(/cart/i, 'bag') +'</div>')
      }
    }
  };

  cartUpdateCallback = function (cart) {
    // Update quantity and price
    updateCountPrice(cart);
    freeGiftHandler(cart);
    // .then(buildCart(cart));
  };

  var discountCode = '';
  freeGiftHandler = function (cart, productId, errorMessage) {

    //-439 -454
    
    
    
    
    //if not doing the above gift thing, must do this instead:
    buildCart(cart, productId, errorMessage);
	return;
  }

  buildCart = function (cart, productId, errorMessage) {
    // Start with a fresh cart div
    $cartContainer.empty();

    // Show empty cart
    if (cart.item_count === 0) {
      $cartContainer
        .append('<p class="empty-cart-msg">' + "Your bag is currently empty." + '</p>');
      cartCallback(cart);
      return;
    }

    // Handlebars.js cart layout
    var items = [],
        item = {},
        data = {},
        source = $("#CartTemplate").html(),
        template = Handlebars.compile(source);

    // Add each item to our handlebars.js data
    $.each(cart.items, function(index, cartItem) {
      variantSelector(index, cartItem.handle, cartItem.variant_id);

      /* Hack to get product image thumbnail
       *   - If image is not null
       *     - Remove file extension, add _small, and re-add extension
       *     - Create server relative link
       *   - A hard-coded url of no-image
      */
      if (cartItem.image != null){
        var prodImg = cartItem.image.replace(/(\.[^.]*)$/, "_medium$1").replace('http:', '');
      } else {
        var prodImg = "//cdn.shopify.com/s/assets/admin/no-image-medium-cc9732cb976dd349a0df1d39816fbcc7.gif";
      }
      // Create item's data object and add to 'items' array
      item = {
        id: cartItem.variant_id,
        line: index + 1, // Shopify uses a 1+ index in the API
        url: cartItem.url,
        img: prodImg,
        name: cartItem.product_title,
        type: cartItem.product_type,
        variation: cartItem.variant_title,
        variation_color: cartItem.variant_options[0],
        variation_size: cartItem.variant_options[1],
        properties: cartItem.properties,
        itemAdd: cartItem.quantity + 1,
        itemMinus: cartItem.quantity - 1,
        itemQty: cartItem.quantity,
        price: Shopify.formatMoney(cartItem.discounted_price, settings.moneyFormat),
        priceNum: cartItem.discounted_price,
        discounted_price: cartItem.discounted_price,
        vendor: cartItem.vendor
      };
      $.extend(item, {isGift: function() {
        return this.type == 'Gift' || this.discounted_price == 0;}
      });
      $.extend(item, {isGWP: function() {
        return this.discounted_price == 0;}
      });

      items.push(item);
    });

    // Gather all cart data and add to DOM
    data = {
      items: items,
      note: cart.note,
      totalPrice: Shopify.formatMoney(cart.total_price, settings.moneyFormat)
    }

    $cartContainer.append(template(data));

    if (productId && errorMessage) {
        $(".product-" + productId + " .ajax-cart-qty-error").html(errorMessage);
    }

    cartCallback(cart);
  };

  //variant selector project
  //-There are no variant infos available here
  //--can't slow down the opening of the cart drawer
  //-don't really want to add a whole lot of stuff into handlebars
  //Possible: use the item url, grab the entire page, pull out the select,
  // which should have an option selected already.
  variantSelector = function(index, handle, current_id) {
      $.ajax({
          url:'/products/'+handle+'.js',
          dataType: 'json',
          success: function (product) {
              if (product.variants.length <= 1 ) {
                  return;
              }

              var selectedVariant = "";
              var availableColors = [];
              var availableSizes = [];
              var availableVariants = {};
              product.variants.forEach(function (variant) {
                  if (variant.available) {
                      if (variant.id === current_id) {
                          selectedVariant = variant;
                      }

                      var color = variant.option1;
                      if (availableColors.indexOf(color) < 0) {
                          availableColors.push(color);
                      }

                      if (!availableVariants[color]) {
                          availableVariants[color] = [];
                      }

                      var size = variant.option2;
                      availableVariants[color].push(size);
                      if (availableSizes.indexOf(size) < 0) {
                          availableSizes.push(size);
                      }
                  }
              });

              if (availableColors.length <= 1 && availableSizes.length <= 1) {
                  return;
              }

              if (availableColors.length === 1) {
                  // Color variants in text
                  var colorInText = '<div class="option-color productEdit hide"><label for="color">' + "COLOR" +'</label>';
                  availableColors.forEach(function (color) {
                      colorInText += '<p>' + color + '</p>';
                      colorInText += '<select class="hide"><option data-sizes="' + availableVariants[color].join(",") +'" value="' + color + '" selected="selected">' + color + '</option></select>';
                  });
                  colorInText += '</div>';
              } else {
                  // Color variants in select dropdown
                  var optionColors = '<div class="option-color productEdit hide"><label for="color">' + "COLOR" +'</label><select data-id="' + current_id + '">';
                  availableColors.forEach(function (color) {
                      var colorSelected = selectedVariant.option1 === color ? 'selected="selected"' : "";
                      var isDefault = selectedVariant.option2 === color ? 'default="true"' : "";
                      optionColors += '<option ' + isDefault + ' data-sizes="'+ availableVariants[color].join(",") +'" value="' + color + '"' + colorSelected + '>' + color + '</option>';
                  });
                  optionColors += '</select></div>';
              }

              if (availableSizes.length === 1) {
                  // Size variants in text
                  var sizeInText = '<div class="option-size productEdit hide"><label for="size">' + "SIZE" + '</label>';
                  availableSizes.forEach(function(size) {
                      sizeInText += '<p>'+ size + '</p>';
                      sizeInText += '<select class="hide"><option value="' + size + '" selected="selected">' + size + '</option></select>';
                  });
                  sizeInText += '</div>';
              } else {
                  // Size variants in select dropdown
                  var optionSizes = '<div class="option-size productEdit hide"><label for="size">' + "SIZE" + '</label><select>';
                  availableSizes.forEach(function(size) {
                      var sizeSelected = selectedVariant.option2 === size ? 'selected="selected"' : "";
                      var isDefault = selectedVariant.option2 === size ? 'default="true"' : "";
                      optionSizes += '<option ' + isDefault + ' value="' + size + '"' + sizeSelected + '>'+ size + '</option>';
                  });
                  optionSizes += '</select></div>';
              }

              var $parent = $('#CartContainer .ajaxcart[data-line='+(1+parseInt(index))+'] .desktop-8 > p:first-child');
              if ($parent.length == 0){
                  console.log('could not find current Variant Title');
                  return;
              }
              $parent.find('span').remove();
              $parent.find('select').remove();
              $parent.find('.option-size').remove();
              $parent.find('.option-color').remove();
              $parent.append(colorInText, optionColors, sizeInText, optionSizes);

              $body.off('change', '.option-color select');
              $body.on('change', '.option-color select', function() {
                  var variantId = $(this).data("id");
                  var selected = $(this).find(":selected");
                  var sizes = selected.data("sizes") ? selected.data("sizes").split(",") : [];

                  $('.product-' + variantId + ' .option-size select option').each(function() {
                      if (sizes.indexOf($(this).val()) < 0) {
                          $(this).attr("disabled", "disabled").removeAttr("selected");
                      } else {
                          $(this).removeAttr("disabled");
                      }
                  });

                  if ($('.product-' + variantId + ' .option-size select option:not([disabled])[default=true]').size() === 0) {
                      $('.product-' + variantId + ' .option-size select option:not([disabled]):first').prop("selected", true);
                  } else {
                      $('.product-' + variantId + ' .option-size select option[default=true]:first').prop("selected", true);
                  }
              });

              $body.off('click', '.option-update');
              $body.find('.option-update').on('click', function(){
                  var id = $(this).data("id");
                  var productId = $(".product-" + id);
                  var selectedColor = $(".product-" + id + " .option-color select").val();
                  var selectedSize = $(".product-" + id + " .option-size select").val();
                  var selectedVariantId = "";

                  if (id !== current_id) {
                      return;
                  }

                  // Set the variant id for selected color and size variants
                  product.variants.forEach(function (variant) {
                      if (variant.available) {
                          var color = variant.option1;
                          var size = variant.option2;
                          if (selectedSize === size && selectedColor == color) {
                              selectedVariantId = variant.id;
                              $.cookie("productDefaultSize", selectedSize, { path: '/' });
                          }
                      }
                  });

                  if (current_id == selectedVariantId) {
                      var $errorMessage = $body.find(".product-" + id + " .error");
                      $errorMessage.html("");

                      $(".product-" + id + " .productView").removeClass("hide");
                      $(".product-" + id + " .productEdit").addClass("hide");

                      return;
                  }

                  //Removed the old variant and add new one
                  $.ajax({
                      type: 'POST',
                      url: '/cart/add.js',
                      data: {
                          quantity: $(".product-" + id + " .ajaxcart__qty-num").val(),
                          id: selectedVariantId
                      },
                      dataType: 'json',
                      success: function(){
                          var params = {
                              type: 'POST',
                              url: '/cart/change.js',
                              data: 'quantity=0&id=' + current_id,
                              dataType: 'json',
                              success: function(cart) {
                                  $.getJSON('/cart.js', function (cart) {
                                      buildCart(cart);
                                  });
                              },
                              error: function(XMLHttpRequest, textStatus) {
                                  ShopifyAPI.onError(XMLHttpRequest, textStatus);
                              }
                          };
                          jQuery.ajax(params);
                      },
                      error: function(XMLHttpRequest, textStatus) {
                          var $errorMessage = $body.find(".product-" + id + " .error");
                          var data = eval('(' + XMLHttpRequest.responseText + ')');
                          if (data.status == 422 || data.status == 404) {
                              if (data.status == 422) {
                                  $errorMessage.html(data.description);
                              }
                          } else {
                              $errorMessage.html("");
                              $(".product-" + id + " .productView").removeClass("hide");
                              $(".product-" + id + " .productEdit").addClass("hide");
                          }
                      }
                  })
              });
          }
      });
  }

  cartCallback = function(cart) {
    updateCountPrice(cart);
    $body.removeClass('drawer--is-loading');
    try{Shopify.StorefrontExpressButtons.initialize();}catch(e){console.log(e);};
    $body.trigger('ajaxCart.afterCartLoad', cart);
    //checkAjaxAdjust();
  };

  adjustCart = function () {
    // Display product edit elements and hide the product view elements
    $body.off('click', '.cart-edit-btn');
    $body.find(".option-color, .option-size").remove();
    $body.on('click', ".cart-edit-btn", function(){

        var $id = $(this).data("id");
        var $productId = $(".product-" + $id);
        if ($productId.hasClass("loading")) {
            return;
        }

        $(".productView").removeClass("hide");
        $(".productEdit").addClass("hide");

        var $productView = $(".product-" + $id + " .productView");
        var $productEdit = $(".product-" + $id + " .productEdit");

        var $productUpdate = $(".product-" + $id + " .option-update");
        var $productCancel = $(".product-" + $id + " .option-cancel");

        if($productEdit) {
            $(".product-" + $id + " .ajax-cart-qty-error").addClass("hide");
        }

        $productView.addClass("hide");
        $productEdit.removeClass("hide");

        // Display the update button only the color and size variant avialable cart item
        if ($productEdit.hasClass("option-color") && $productEdit.hasClass("option-size")) {
            $productUpdate.removeClass("hide");
            $productCancel.addClass("hide");
        } else {
            $productUpdate.addClass("hide");
            $productCancel.removeClass("hide");
        }

        var selected = $(".product-" + $id + " .option-color select").find(":selected");
        if (selected) {
            var sizes = selected.data("sizes") ? selected.data("sizes").split(",") : [];

            $(".product-" + $id + " .option-size select option").each(function () {
                if (sizes.indexOf($(this).val()) < 0) {
                    $(this).attr("disabled", "disabled").removeAttr("selected");
                } else {
                    $(this).removeAttr("disabled");
                }
            });
        }
    });

    // Display cancel button for single variant cart items
    $body.off('click', '.option-cancel');
    $body.on('click', '.option-cancel', function() {
        var $id = $(this).data("id");
        var $productId = $(".product-" + $id);
        var $productView = $(".product-" + $id + " .productView");
        var $productEdit = $(".product-" + $id + " .productEdit");

        $productView.removeClass("hide");
        $productEdit.addClass("hide");
    });

    // Remove the particular cart item from the cart
    $body.off('click', '.option-delete');
    $body.on('click', ".option-delete", function(){
        $(this).attr("disabled", "disabled");
        var item_id = $(this).data("id");
        var item_line = $(".product-" + item_id + " .ajaxcart__qty-adjust").data('line');
        updateQuantity(item_line, 0);
    });

    // Delegate all events because elements reload with the cart

    // Add or remove from the quantity
    $body.off('click', '.ajaxcart__qty-adjust');
    $body.on('click', '.ajaxcart__qty-adjust', function() {
      var $el = $(this),
          line = $el.data('line'),
          $qtySelector = $el.siblings('.ajaxcart__qty-num'),
          qty = parseInt($qtySelector.val().replace(/\D/g, ''));
      setAjaxAdjust($qtySelector.data('id'),qty);

      var qty = validateQty(qty);
      var $currentId = $(".ajaxcart__qty-num[data-line='" + line + "']").data("id");

      $(".product-" + $currentId + " .ajaxcart__qty-adjust").attr("disabled", "disabled");

      // Add or subtract from the current quantity
      if ($el.hasClass('ajaxcart__qty--plus')) {
        qty += 1;
      } else {
        qty -= 1;
        if (qty <= 0) qty = 0;
      }

      //when click ajaxcart__qty-adjust, first the count will be increased or decreased and after that the API runs
      $qtySelector.val(qty);
      // If it has a data-line, update the cart.
      // Otherwise, just update the input's number
      if (line) {
        updateQuantity(line, qty);
      }

    });

    // Update quantity based on input on change
    $body.off('change', '.ajaxcart__qty-num');
    $body.on('change', '.ajaxcart__qty-num', function() {
      var $el = $(this),
          line = $el.data('line'),
          qty = parseInt($el.val().replace(/\D/g, ''));

      var qty = validateQty(qty);

      // If it has a data-line, update the cart
      if (line) {
        updateQuantity(line, qty);
      }

    });

    // Prevent cart from being submitted while quantities are changing
    $body.off('submit', 'form.ajaxcart');
    $body.on('submit', 'form.ajaxcart', function(evt) {
      if (isUpdating) {
        evt.preventDefault();
      }
    });

    // Highlight the text when focused
    $body.off('focus', '.ajaxcart__qty-adjust');
    $body.on('focus', '.ajaxcart__qty-adjust', function() {
      var $el = $(this);
      setTimeout(function() {
        $el.select();
      }, 50);
    });

    function updateQuantity(line, qty) {
      isUpdating = true;

      // Add activity classes when changing cart quantities
      var $row = $('.ajaxcart__row[data-line="' + line + '"]').addClass('is-loading');

      if (qty === 0) {
        $row.parent().addClass('is-removed');
      }
      // Slight delay to make sure removed animation is done
      setTimeout(function() {
        ShopifyAPI.changeItem(line, qty, adjustCartCallback);
      }, 250);
    }

    // Save note anytime it's changed
    $body.off('change', 'textarea[name="note"]');
    $body.on('change', 'textarea[name="note"]', function() {
      var newNote = $(this).val();

      // Update the cart note in case they don't click update/checkout
      ShopifyAPI.updateCartNote(newNote, function(cart) {});
    });
  };

  adjustCartCallback = function (cart, productId, errorMessage) {
    isUpdating = false;
    // Update quantity and price
    updateCountPrice(cart);
    // Reprint cart on short timeout so you don't see the content being removed
    setTimeout(function() {
      ShopifyAPI.getCart(function(cart) {
        return freeGiftHandler(cart, productId, errorMessage);
      });
      //ShopifyAPI.getCart(buildCart, productId, errorMessage);
    }, 150)
  };

  createQtySelectors = function() {
    // If there is a normal quantity number field in the ajax cart, replace it with our version
    if ($('input[type="number"]', $cartContainer).length) {
      $('input[type="number"]', $cartContainer).each(function() {
        var $el = $(this),
            currentQty = $el.val();

        var itemAdd = currentQty + 1,
            itemMinus = currentQty - 1,
            itemQty = currentQty;

        var source   = $("#AjaxQty").html(),
            template = Handlebars.compile(source),
            data = {
              id: $el.data('id'),
              itemQty: itemQty,
              itemAdd: itemAdd,
              itemMinus: itemMinus
            };

        // Append new quantity selector then remove original
        $el.after(template(data)).remove();
      });
    }
  };

  qtySelectors = function() {
    // Change number inputs to JS ones, similar to ajax cart but without API integration.
    // Make sure to add the existing name and id to the new input element
    var numInputs = $('input[type="number"]');

    if (numInputs.length) {
      numInputs.each(function() {
        var $el = $(this),
            currentQty = $el.val(),
            inputName = $el.attr('name'),
            inputId = $el.attr('id');

        var itemAdd = currentQty + 1,
            itemMinus = currentQty - 1,
            itemQty = currentQty;

        var source   = $("#JsQty").html(),
            template = Handlebars.compile(source),
            data = {
              id: $el.data('id'),
              itemQty: itemQty,
              itemAdd: itemAdd,
              itemMinus: itemMinus,
              inputName: inputName,
              inputId: inputId
            };

        // Append new quantity selector then remove original
        $el.after(template(data)).remove();
      });

      // Setup listeners to add/subtract from the input
      $('.js-qty__adjust').off('click');
      $('.js-qty__adjust').on('click', function() {
        var $el = $(this),
            id = $el.data('id'),
            $qtySelector = $el.siblings('.js-qty__num'),
            qty = parseInt($qtySelector.val().replace(/\D/g, ''));

        var qty = validateQty(qty);

        // Add or subtract from the current quantity
        if ($el.hasClass('js-qty__adjust--plus')) {
          qty += 1;
        } else {
          qty -= 1;
          if (qty <= 1) qty = 1;
        }

        // Update the input's number
        $qtySelector.val(qty);
      });
    }
  };

  validateQty = function (qty) {
    if((parseFloat(qty) == parseInt(qty)) && !isNaN(qty)) {
      // We have a valid number!
    } else {
      // Not a number. Default to 1.
      qty = 1;
    }
    return qty;
  };

  module = {
    init: init,
    load: loadCart
  };



  return module;

}(ajaxCart || {}, jQuery));
